import { render, staticRenderFns } from "./AssignAnnotationPanel.vue?vue&type=template&id=94984c3e&scoped=true&"
import script from "./AssignAnnotationPanel.vue?vue&type=script&lang=js&"
export * from "./AssignAnnotationPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssignAnnotationPanel.vue?vue&type=style&index=0&id=94984c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94984c3e",
  null
  
)

export default component.exports